import axios from 'axios';
import { call, cancelled } from 'redux-saga/effects';

export const request = (config = {}, cancellable = true) => {
  return call(function* () {
    const source = axios.CancelToken.source();
    const cancelConfig = cancellable ? { cancelToken: source.token } : {};
    try {
      return yield call(axios.request, { ...cancelConfig, ...config });
    } finally {
      if (cancellable) {
        if (yield cancelled()) {
          source.cancel();
        }
      }
    }
  });
};

export const get = (url, config = {}) => {
  return request({ method: 'get', url, ...config });
};

export const post = (url, data, config = {}) => {
  return request({ method: 'post', url, data, ...config });
};

export const patch = (url, data, config = {}) => {
  return request({ method: 'patch', url, data, ...config });
};

export const del = (url, config = {}, cancellable = true) => {
  return request({ method: 'delete', url, ...config }, cancellable);
};
